import {Directive, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {SbModalState} from './modal-state.service';

@Directive({
  selector: '[sbmodal]',
  standalone: false,
})
export class SbModalTemplateDirective implements OnInit, OnDestroy {
  @Input('sbmodal') sbmodal: string;

  tpl: TemplateRef<any>;
  id: string;

  constructor(
    public confirmTemplate: TemplateRef<any>,
    public state: SbModalState
  ) {}

  ngOnInit() {
    this.tpl = this.confirmTemplate;
    this.id = this.sbmodal;
    this.state.templates.set(this.id, this.tpl);
  }

  ngOnDestroy() {
    this.state.templates.delete(this.id);
    this.state.options.delete(this.id);
    this.state.modals.delete(this.id);
    this.state.modalOptions.delete(this.id);
    this.state.navigationSharedData = null;
  }
}
